import React from 'react';

const StatusBadge = ({ itemStatus, width = '100%' }) => {
	let badgeClass = '';
	switch (itemStatus) {
		case 'Draft':
		case 'Concept':
		case 'Paused':
		case 'Sold':
		case 'Not Available':
		case 'Expired':
			badgeClass = 'badge-secondary';
			break;
		case 'Closed':
			badgeClass = 'badge-black';
			break;
		case 'Estimated':
		case 'Invoiced':
		case 'Sourced':
		case 'Inspected':
		case 'Ready for Testing':
		case 'Ready for Inbounding':
		case 'Ready for Packing':
		case 'Ready To Ship':
		case 'Ready for Repair':
		case 'Processing':
		// case 'Purchased':
		// 	badgeClass = 'badge-info';
		// 	break;
		case 'Canceled':
		case 'Cancelled':
		case 'Void':
			badgeClass = 'badge-dark-gray';
			break;
		case 'Pending Manager':
			badgeClass = 'badge-warning disabled';
			break;
		case 'Pending Customer':
		case 'Pending':
		case 'In Repair':
		case 'Sourcing':
		case 'Repairing':
			badgeClass = 'badge-warning';
			break;
		case 'Credit Note':
		case 'Open':
		case 'Purchased':
		case 'Reserved':
		case 'Unpaid':
		case 'Unprocessed':
			badgeClass = 'badge-orange';
			break;
		case 'Pending':
		case 'Inspection':
		case 'Need Collection':
		case 'transit':
		case 'TRANSIT':
			badgeClass = 'badge-dark-warning';
			break;
		case 'For Transit':
		case 'Shipped':
		case 'Submitted':
		case 'Paid':
		case 'Approved':
		case 'Accepted':
		case 'Verified':
		case 'Available':
		case 'Active':
		case 'Delivered':
		case 'DELIVERED':
			badgeClass = 'badge-success';
		break;
		case 'Completed':
			badgeClass = 'badge-dark-green';
		break;
		case 'For Credit Note':
		case 'Inspection Approval':
		case 'Collected':
		case 'Inbounded':
		case 'Received':
		case 'In Progress':
		case 'Dispatched':
		case 'DISPATCHED':
			badgeClass = 'badge-primary';
			break;
		case 'For Approval':
		case 'Unrepairable':
		case 'Incomplete':
		case 'Unverified':
		case 'Not Registered':
		case 'Inactive':
			badgeClass = 'badge-danger';
			break;

		// case 'Concept':
		// 	badgeClass = 'badge-light-orange';
		// 	break;
		case 'Customer':
		case 'Transit Company':
			badgeClass = 'badge-title';
			break;
		default:
			badgeClass = '';
	}

	return (
		<div className={`badge ${badgeClass}`} style={{ width: width }}>
			{itemStatus === 'Credit Note' || itemStatus === 'Unprocessed'
				? 'Open'
				: itemStatus === 'Need Collection'
					? 'For Collection'
					: itemStatus}
		</div>
	);
};

export default StatusBadge;
